var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLtoeGetCredentialedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64.9 57.2",
    style: {
      enableBackground: "new 0 0 64.9 57.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BFDDF1;}\n\t.st1{fill:#7FBAE3;}\n\t.st2{fill:#2A3953;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#7FCA9B;}\n\t.st5{fill:#FFE2B6;}\n\t.st6{fill:#FFC56E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2135",
    transform: "translate(-1775.672 -3089.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2119",
    transform: "translate(1775.672 3092.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2116",
    transform: "translate(1.063 1.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1457",
    className: "st0",
    d: "M15.4,0h32.1c2.8,0,5,2.2,5,5v41.9c0,2.8-2.2,5-5,5H15.4c-2.8,0-5-2.2-5-5V5 C10.4,2.2,12.6,0,15.4,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2117",
    transform: "translate(34.125 1.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    className: "st1",
    d: "M16.7,0h-6.4v51.9h6.4c1.5,0,2.7-1.2,2.7-2.7l0,0V2.7C19.4,1.2,18.2,0,16.7,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2118",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    className: "st2",
    d: "M50.8,54.1H14.1c-2.1,0-3.7-1.7-3.7-3.7V3.7c0-2,1.6-3.7,3.7-3.7h36.8c2.1,0,3.7,1.7,3.7,3.7 v46.6C54.6,52.4,52.9,54.1,50.8,54.1z M14.1,2.1c-0.9,0-1.6,0.7-1.6,1.6v46.6c0,0.9,0.7,1.6,1.6,1.6h36.8c0.9,0,1.6-0.7,1.6-1.6 V3.7c0-0.9-0.7-1.6-1.6-1.6H14.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2120",
    transform: "translate(1781.333 3098.36)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1458",
    x: 10.4,
    className: "st3",
    width: 32.9,
    height: 42.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2121",
    transform: "translate(1809.797 3098.36)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1459",
    x: 10.4,
    className: "st0",
    width: 4.4,
    height: 42.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2122",
    transform: "translate(1786.543 3117.963)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1460",
    x: 10.4,
    y: 0,
    className: "st4",
    width: 5.5,
    height: 5.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2123",
    transform: "translate(1786.543 3129.356)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1461",
    x: 10.4,
    y: 0,
    className: "st4",
    width: 5.5,
    height: 5.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2124",
    transform: "translate(1780.271 3097.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    className: "st2",
    d: "M44.3,44.3H11.4c-0.6,0-1.1-0.5-1.1-1.1V1.1c0-0.6,0.5-1.1,1.1-1.1h32.9 c0.6,0,1.1,0.5,1.1,1.1v42.1C45.4,43.8,44.9,44.3,44.3,44.3z M12.5,42.1h30.8v-40H12.5V42.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2125",
    transform: "translate(1784.693 3106.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    className: "st2",
    d: "M15,7.5c-0.3,0-0.6-0.1-0.8-0.4l-3.6-4c-0.4-0.4-0.4-1.1,0.1-1.5c0.4-0.4,1.1-0.4,1.5,0.1l0,0 L15,4.8l3.7-4.5c0.4-0.4,1.1-0.5,1.5-0.1s0.5,1,0.1,1.5l-4.5,5.4C15.6,7.4,15.3,7.5,15,7.5L15,7.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2126",
    transform: "translate(1785.48 3116.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    className: "st2",
    d: "M17,7.7h-5.6c-0.6,0-1.1-0.5-1.1-1.1V1.1c0-0.6,0.5-1.1,1.1-1.1H17c0.5,0,1,0.5,1,1.1v5.5 C18,7.2,17.6,7.7,17,7.7z M12.5,5.5h3.4V2.1h-3.4V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2127",
    transform: "translate(1785.48 3128.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    className: "st2",
    d: "M17,7.7h-5.6c-0.6,0-1.1-0.5-1.1-1.1V1.1c0-0.6,0.5-1.1,1.1-1.1H17c0.5,0,1,0.5,1,1.1v5.5 C18,7.2,17.6,7.7,17,7.7z M12.5,5.5h3.4V2.1h-3.4V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2128",
    transform: "translate(1795.055 3110.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    className: "st2",
    d: "M25.1,2.1H11.4c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h13.7c0.6,0,1.1,0.5,1.1,1.1 C26.2,1.6,25.7,2.1,25.1,2.1L25.1,2.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2129",
    transform: "translate(1795.055 3119.689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    className: "st2",
    d: "M25.1,2.1H11.4c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h13.7c0.6,0,1.1,0.5,1.1,1.1 C26.2,1.6,25.7,2.1,25.1,2.1L25.1,2.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2130",
    transform: "translate(1795.055 3131.067)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    className: "st2",
    d: "M25.1,2.1H11.4c-0.6,0-1.1-0.4-1.1-1s0.4-1.1,1-1.1c0,0,0,0,0.1,0h13.7c0.6,0,1.1,0.4,1.1,1 C26.2,1.6,25.7,2.1,25.1,2.1L25.1,2.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2131",
    transform: "translate(1790.137 3090.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1462",
    className: "st5",
    d: "M15.4,0h5.3c2.8,0,5,2.2,5,5v1.1c0,2.8-2.2,5-5,5h-5.3c-2.8,0-5-2.2-5-5V5 C10.4,2.2,12.6,0,15.4,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2132",
    transform: "translate(1801.84 3090.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    className: "st6",
    d: "M11.4,0h-1.1v11.1h1.1c1.4,0,2.5-1.1,2.5-2.5V2.5C13.9,1.1,12.8,0,11.4,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2133",
    transform: "translate(1789.074 3089.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    className: "st2",
    d: "M24.2,13.3H13.9c-2,0-3.5-1.6-3.5-3.5V3.5c0-2,1.6-3.5,3.5-3.5h10.3c2,0,3.5,1.6,3.5,3.5v6.2 C27.8,11.7,26.2,13.3,24.2,13.3z M13.9,2.1c-0.8,0-1.4,0.6-1.4,1.4v6.2c0,0.8,0.6,1.4,1.4,1.4h10.3c0.8,0,1.4-0.6,1.4-1.4V3.5 c0-0.8-0.6-1.4-1.4-1.4H13.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2134",
    transform: "translate(1792.649 3094.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    className: "st2",
    d: "M19.5,2.1h-8.1c-0.6,0-1-0.5-1-1.1s0.5-1,1-1h8.1c0.6,0,1.1,0.4,1.1,1 C20.7,1.6,20.2,2.1,19.5,2.1C19.6,2.1,19.6,2.1,19.5,2.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtoeGetCredentialedIcon);
export default __webpack_public_path__ + "static/media/ltoe-get-credentialed-icon.57ed91c4f18e03dba11a307d0131e9bf.svg";
export { ForwardRef as ReactComponent };